module.exports = __webpack_public_path__ + "img/move.2c2d9b32.svg";